// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.data.OccupationalDataResponse */
/* istanbul ignore next */
@GandalfModel
export class OccupationalDataResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	conceptCode!: string;

	@GandalfProperty({ designType: String })
	conceptName!: string;

	@GandalfProperty({ designType: Number })
	dataId!: number;

	@GandalfProperty({ designType: String })
	preferredConceptName!: string;

}
